module.exports = __webpack_public_path__ + "img/522.24a5367e.png";